document.addEventListener("DOMContentLoaded", () => {
    const container = document.querySelector('.widerruf');
    if (!container) return;

    const form = container.querySelector('form');
    const seminarnummer = form.querySelector('#widerruf_seminarnummer');
    const freitext = form.querySelector('#widerruf_freitext');

    form.addEventListener('input', () => {
        seminarnummer.setCustomValidity('')

        if (!seminarnummer.value.trim() && !freitext.value.trim()) {
            seminarnummer.setCustomValidity('Nennen Sie uns bitte die Seminarnummer oder beschreiben Sie Ihr Anliegen im Freitextfeld.')
        }
    });
})